//获取运营商
let getOpt = [
    {name:'移动',val:1},
    {name:'联通',val:2},
    {name:'电信',val:3},
    {name:'广电',val:5},
    {name:'聚合',val:6}
]

export default getOpt;


// WEBPACK FOOTER //
// ./src/assets/script/base.js